module.exports = __webpack_public_path__ + "static/media/ruanfuwu.ffa5ada1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/softServices/ruanfuwu.jpg
// module id = 474
// module chunks = 0